<template>
  <div class="btn" :class="{disabled: disabled}" @click="handleClick">
    <slot/>
  </div>
</template>

<script>
    export default {
        name: "ZButton",
        props: {
            disabled: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            handleClick() {
                // 工具条按钮默认只是 div，禁用态需要在组件内拦截，避免父页面 loading 时仍然重复触发请求。
                if (this.disabled) {
                    return
                }
                this.$emit("click")
            }
        }
    }
</script>

<style lang="scss" scoped>
  .btn {
    @include button-theme;
    
    user-select: none;
    width: 80%;
    margin: 0 auto 20px;
    height: 40px;
    line-height: 40px;
    opacity: 1;
    border-radius: 26px;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
  }

  .btn:hover {
    @include button-theme-hover;
  }

  .btn[type="warning"] {
    background: rgba(255, 0, 0, 0.1);
    border: 1px solid rgba(255, 0, 0, 1);
    color: rgba(255, 0, 0, 1);
  }

  .btn[type="warning"]:hover {
    background: rgba(255, 0, 0, 1);
    color: rgba(255, 255, 255, 1);
  }

  .btn.disabled,
  .btn.disabled:hover {
    cursor: not-allowed;
    opacity: .55;
  }
</style>



// WEBPACK FOOTER //
// src/components/TableToolBar/TButton.vue